import { Injector, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable, switchMap, tap } from 'rxjs';
import { FullScreenDialogConfig } from '../../../_config/full-screen-dialog-config';
import { UploadedDocument } from '../../../_core/models/uploaded-document';
import { BucketService } from '../../../_core/services/bucket.service';
import { IconService } from '../../../_core/services/icon.service';
import { PdfDialogComponent } from '../../../_widgets/pdf-dialog/pdf-dialog.component';
import { ICommand } from './i-command';

export class DownloadDocumentCommand
  implements
    ICommand<
      { path: string; nome: string; mimeType: string },
      { getFile: (path: string) => Observable<any> }
    >
{
  service: { getFile: (path: string) => Observable<any> };
  protected dialog: MatDialog;
  isLoading?: boolean;
  icon = 'download';
  label = 'Scarica documento';
  tooltip = 'Scarica documento';
  type: 'warn' | 'primary' | 'accent' = 'accent';
  layout?: 'flat' | 'raised' | 'normal';
  constructor(
    private inj: Injector,
    service: Type<{
      getFile: (path: string) => Observable<any>;
    }> = BucketService
  ) {
    this.service = this.inj.get(service);
    this.dialog = this.inj.get(MatDialog);
    const iconService = this.inj.get(IconService);
    iconService.getIcons(['download']);
  }
  execute(
    element: { path: string; nome: string; mimeType: string },
    ...args: unknown[]
  ) {
    return this.downloadDocument(element);
  }
  isDisabled(element?: { path: string; nome: string; mimeType: string }) {
    return false;
  }
  isHidden(element?: { path: string; nome: string; mimeType: string }) {
    return false;
  }

  private downloadDocument(doc: {
    path: string;
    nome: string;
    mimeType: string;
  }) {
    return this.getFile(doc).pipe(
      tap((url) => {
        var link = document.createElement('a');
        link.download = doc.nome;
        link.href = url;
        link.click();
      })
    );
  }

  protected getFile(doc: { path: string; nome: string; mimeType: string }) {
    return this.service.getFile(doc.path).pipe(
      map((res) => {
        const blob = new Blob([res], { type: doc?.mimeType });
        const url = window.URL.createObjectURL(blob);
        return url;
      })
    );
  }
}
